import { FormFieldWidget, FormStringFieldMultiWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import Tag from './Tag.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Search],
    ttype: ModelFieldType.String,
    name: 'tradeOrderSearch',
    model: ['deli.aries.seller.SellerDistributorTradeOrder'],
    widget: 'Tag',
    multi: true
  })
)
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Search],
    ttype: ModelFieldType.String,
    name: 'tradeOrderCodesQuery',
    model: ['deli.aries.seller.SellerDistributorTmsOrder'],
    widget: 'Tag',
    multi: true
  })
)
@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: [ViewType.Search],
        ttype: ModelFieldType.String,
        name: 'tradeOrderCodeSearch',
        model: ['deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'],
        widget: 'Tag',
        multi: true
    })
)
@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: [ViewType.Search],
        ttype: ModelFieldType.String,
        name: 'erpCodeSearch',
        model: ['deli.aries.seller.SellerDistributorTmsOrder'],
        widget: 'Tag',
        multi: true
    })
)
@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: [ViewType.Search],
        ttype: ModelFieldType.String,
        name: 'erpCodeList',
        model: ['deli.aries.seller.DeliAriesSellerPurchasingPlanAuthProxy'],
        widget: 'Tag',
        multi: true
    })
)
@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: [ViewType.Search],
        ttype: ModelFieldType.String,
        name: 'codeSearch',
        model: ['deli.aries.seller.SellerDistributorTmsOrder'],
        widget: 'Tag',
        multi: true
    })
)
@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: [ViewType.Search],
        ttype: ModelFieldType.String,
        name: 'billPeriodSearch',
        model: ['deli.aries.resident.PerformanceDetailProxy'],
        widget: 'Tag',
        multi: true
    })
)
export class MyFormStringFieldMultiWidget extends FormStringFieldMultiWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(Tag);
    return this;
  }
}
